import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Paper from "@material-ui/core/Paper/Paper";
import ContractForm from "../../components/Contracts/ContractForm";
import Toolbar from "../../components/Toolbar/Toolbar";
import CardContent from "@material-ui/core/CardContent/CardContent";

const ContractsCreate = ({classes, person, formUrl, redirectAfterSubmit}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('contracts.new_contract')}
        />

        <Paper>
            <CardContent>
                <ContractForm
                    person={person}
                    formUrl={formUrl}
                    isEdit={false}
                    redirectAfterSubmit={redirectAfterSubmit}
                />
            </CardContent>
        </Paper>
    </Layout>
);

export default ContractsCreate;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/contracts/Create.jsx